// import ReactDOM from 'react-dom';
import React, { Component } from 'react';
import ReactMap from '../containers/ReactMap';
import Interface from '../containers/Interface';

const TOKEN = 'pk.eyJ1IjoicnVpOTUiLCJhIjoiY2thajlwOHJ6MGFrNTJ4cjVjenlyMjBvbSJ9.v8FLQRhheWqVzz2mI5ZOKQ';


// const LONG = -122.646587;
// const LAT = 45.539776;
// const LONG = 114.177216;  // Hong Kong
//  const LAT = 22.302711;
// // const ZOOM = 16;
// // const STYLE_ID = 'rui95/ckh8tlaxv3hyz19s5fwujjnk2';


const LONG = -122.66661759147235;
const LAT = 45.51886025215052;
const ZOOM = 18;
//const STYLE_ID = 'ryantm/cj8m5f0136ll12sk7nm8dj00k';
//const STYLE_ID = 'rui95/ckhd01a3f1zl319o4iemomt57';
//const STYLE_ID = 'mapbox/dark-v10';
const STYLE_ID = 'mapbox-map-design/ckhqrf2tz0dt119ny6azh975y';


export default class App extends Component {

  render() {
    return (
      <div>
        <Interface/>
        <ReactMap
          token= { TOKEN }
          longitude= { LONG }
          latitude= { LAT }
          zoom= { ZOOM }
          showPopUp= { true }
          styleID = { STYLE_ID }/>
      </div>
    );
  }
}
